import React, { useCallback } from 'react';

export const useSelectOnChangeValue = (fun?: (value: any) => void) =>
  useCallback(
    ({ target: { value } }: React.ChangeEvent<{ value: unknown }>) => {
      if (fun) fun(value);
    },
    [fun],
  );
